// Rail grouping for the SkuSearchSelect 'rail' layout (Receive delivery).
// Picked design: _parts-picker/2026-10-07-receive-sections/picks.json → j1 = B
// (fragment parts/j1-B.html, root class `rb`): a left category rail with three
// groups — GUTTER, INSULATION, OTHER.
//
// Group membership comes from PICKER_PRIORITY_BY_LINE (never a second name list):
// GUTTER = the gutter priority names in their pinned order, INSULATION = the
// insulation priority names in order, OTHER = every remaining category
// alphabetical. A configured name absent from the live categories is simply not
// drawn; an empty group is omitted.

import type { SkuCategory } from '@gutterinv/shared';
import { PICKER_PRIORITY_BY_LINE } from './sku-picker-order.js';

/** Root class of the rail element — pinned to the picked fragment's root (`.rb`). */
export const RAIL_ROOT_CLASS = 'rb';

export interface RailGroup {
  label: string;
  items: SkuCategory[];
}

export function railGroups(categories: SkuCategory[]): RailGroup[] {
  const byName = new Map(categories.map((c) => [c.name, c]));
  const priorityNames = new Set([
    ...PICKER_PRIORITY_BY_LINE.gutter,
    ...PICKER_PRIORITY_BY_LINE.insulation,
  ]);
  const pick = (names: string[]) =>
    names.map((n) => byName.get(n)).filter((c): c is SkuCategory => c != null);
  const groups: RailGroup[] = [
    { label: 'Gutter', items: pick(PICKER_PRIORITY_BY_LINE.gutter) },
    { label: 'Insulation', items: pick(PICKER_PRIORITY_BY_LINE.insulation) },
    {
      label: 'Other',
      items: categories
        .filter((c) => !priorityNames.has(c.name))
        .sort((a, b) => a.name.localeCompare(b.name)),
    },
  ];
  return groups.filter((g) => g.items.length > 0);
}
